<template>
  <div class="bluefire-wap-wrap">
    <wap-header header-text="用户编辑" :header-visible="true" :back-visible="true" /><!--参数都可以不传-->
    <scroll-refresh>
      <div class="user-detail-wrap">
        <div class="header-area">
          <div class="info-area">
            <div class="name-area">
              <h3>
                <font>{{ editData.custom_name }}</font>
                <i v-if="editData.crm_tel">{{ editData.crm_tel }}</i>
              </h3>
              <h4 v-if="editData.lastvisittime2">最后回访时间：{{ editData.lastvisittime2 | formatDate }}</h4>
            </div>
            <div class="btn-area">
              <img @click="openEwm" v-if="isJiemoJpKrStudent" src="../../assets/wap/icon-userdetail-3.png" alt="">
              <el-button @click="openEdit" state-key="fib.jiemo.net/h5/user/edit-顶部" :state-status="true">编辑</el-button>
            </div>
            <div class="chat-area">
              <div class="chat-content" v-if="editData.crm_qq">
                <img src="../../assets/wap/icon-userdetail-1.png" alt="">
                <span>{{ editData.crm_qq }}</span>
                <Copy :content="editData.crm_qq" @copyCallback="copyClick()">
                  <el-button>复制</el-button>
                </Copy>
              </div>
              <div class="chat-content" v-if="editData.crm_weixin">
                <img src="../../assets/wap/icon-userdetail-2.png" alt="">
                <span>{{ editData.crm_weixin }}</span>
                <Copy :content="editData.crm_weixin" @copyCallback="copyClick()">
                  <el-button>复制</el-button>
                </Copy>
              </div>
            </div>
          </div>
          <div class="card-area">
            <div class="card-content">
              <img src="../../assets/wap/icon-userdetail-4.png" alt="">
              <div class="text-area">
                <span>客户等级</span>
                <em>{{ editData.crm_level_lv_str }}</em>
              </div>
            </div>
            <div class="line-area"></div>
            <div class="card-content">
              <img src="../../assets/wap/icon-userdetail-5.png" alt="">
              <div class="text-area">
                <span>入学时间</span>
                <em>{{ editData.custom_year_str }}</em>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-btn-area">
          <el-button :class="tabLock === 1 ? 'active' : ''" @click="tabClick(1)">基础信息<i></i></el-button>
          <el-button :class="tabLock === 2 ? 'active' : ''" @click="tabClick(2)">签约信息<i></i></el-button>
          <el-button :class="tabLock === 3 ? 'active' : ''" @click="tabClick(3)">回访<i></i></el-button>
          <el-button :class="tabLock === 4 ? 'active' : ''" @click="tabClick(4)">支付<i></i></el-button>
        </div>
        <div class="tab-area basic-info-area" v-show="tabLock === 1">
          <div class="channel-area">
            <span>渠道<br>信息</span>
            <div class="channel-list">
              <span v-for="item in editData.channel_str" :key="item">{{ item }}<i></i></span>
            </div>
          </div>
          <div class="remark-area user-detail-commonbg">
            <div class="user-detail-title">
              <h3><i></i>备注信息</h3>
              <el-button @click="openEdit(2)" state-key="fib.jiemo.net/h5/user/edit-备注信息" :state-status="true">编辑</el-button>
            </div>
            <div class="remark-content">
              {{ editData.crm_memo ? editData.crm_memo : '暂无备注' }}
            </div>
          </div>
          <div class="person-area user-detail-commonbg">
            <div class="user-detail-title">
              <h3><i></i>个人信息</h3>
              <el-button @click="openEdit(3)" state-key="fib.jiemo.net/h5/user/edit-个人信息" :state-status="true">编辑</el-button>
            </div>
            <div class="user-detail-list">
              <div class="list-content">
                <span>昵&emsp;&emsp;称</span>
                <span>{{ editData.custom_nickname_tell }}</span>
              </div>
              <div class="list-content">
                <span>创&ensp;建&ensp;人</span>
                <span>{{ editData.create_person_value }}（{{ editData.create_time }}）</span>
              </div>
              <div class="list-content">
                <span>意向国家</span>
                <span>{{ editData.custom_hope_country_str }}</span>
              </div>
            </div>
          </div>
          <div class="person-area user-detail-commonbg">
            <div class="user-detail-title">
              <h3><i></i>其他信息</h3>
              <el-button @click="openEdit(4)" state-key="fib.jiemo.net/h5/user/edit-其他信息" :state-status="true">编辑</el-button>
            </div>
            <div class="user-detail-list">
              <div class="list-content">
                <span>资源互转</span>
                <span>{{ editData.crm_zhuanxiang || '-' }}</span>
              </div>
              <div class="list-content">
                <span>服务切片</span>
                <span>{{ editData.country_business_str || '-' }}</span>
              </div>
              <div class="list-content">
                <span>活动编码</span>
                <span>{{ editData.activity_code || '-' }}</span>
              </div>
              <div class="list-content" v-if="isJiemoJpStudent">
                <span>芥末日本VIP</span>
                <span>{{ editData.jiemo_vip_str }}</span>
              </div>
              <div class="list-content" v-if="isJiemoJpStudent">
                <span>短期留学</span>
                <span>{{ editData.short_study_abroad_str }}</span>
              </div>
              <div class="list-content">
                <span>介绍人ID</span>
                <span>{{ editData.parent_id || '无' }}</span>
              </div>
              <div class="list-content">
                <span>介绍人姓名</span>
                <span>{{ editData.parent_name || '无' }}</span>
              </div>
            </div>
          </div>
          <training-card :show-id="parseInt(crmId)" :show-type="1"></training-card>
          <training-card :show-id="parseInt(crmId)" :show-type="2"></training-card>
        </div>
        <div class="tab-area sign-info-area" v-show="tabLock === 2">
          <div class="person-area user-detail-commonbg">
            <div class="user-detail-title">
              <h3><i></i>签约信息</h3>
              <el-button @click="openEdit(5)" state-key="fib.jiemo.net/h5/user/edit-签约信息" :state-status="true">编辑</el-button>
            </div>
            <div class="user-detail-list">
              <div class="list-content">
                <span>签约状态</span>
                <span>
                  <jm-dict-select
                    clearable
                    type="dataset"
                    v-model="editData.custom_level"
                    dict-type="student"
                    name="customLevelType"
                    :show="true"
                  />
                </span>
              </div>
              <div class="list-content">
                <span>签约日期</span>
                <span>{{ editData.signing_date }}</span>
              </div>
              <div class="list-content">
                <span>办理国家</span>
                <span>{{ editData.custom_active_country_str }}</span>
              </div>
              <div class="list-content" v-if="hasSignType">
                <span>签约类型</span>
                <span>{{ editData.sign_type_str }}</span>
              </div>
            </div>
          </div>
          <div class="person-area user-detail-commonbg" v-if="mustHaveInterviewForm">
            <div class="user-detail-title">
              <h3><i></i>报名信息</h3>
            </div>
            <div class="user-detail-interview">
              <div class="link-area">
                <div class="first-link">
                  <div class="top-area" @click="openShowImg(editData.interview_form_url)">
                    <h3>报名采集表</h3>
                    <el-button size="medium">预览</el-button>
                  </div>
                  <div class="bottom-area" v-show="editData.signup_form.update_channel || editData.signup_form.update_channel_name || editData.signup_form.update_time">
                    <span>填表时间{{ editData.signup_form.update_channel ? `-${editData.signup_form.update_channel_name}` : '' }}：</span>
                    <span>{{ editData.signup_form.update_time }}</span>
                  </div>
                </div>
                <div class="open-showimg-area" v-if="!isJiemoKrStudent">
                  <router-link :to="{ name: 'interview_signup_table', params: { crm_id: editData.id } }">
                    <div class="img-area">
                      <img src="../../assets/wap/icon-userdetail-inter2.png" alt="">
                    </div>
                    <h3>面试表</h3>
                  </router-link>
                </div>
                <div class="open-showimg-area" @click="downloadCert(currentInterviewObj)" v-if="!isJiemoKrStudent">
                  <div class="img-area">
                    <img src="../../assets/wap/icon-userdetail-inter3.png" alt="">
                  </div>
                  <h3>合格证</h3>
                </div>
              </div>
              <div class="school-area" v-if="!isJiemoKrStudent">
                <span>申请学校</span>
                <div class="school-select">
                  <jm-school-search
                    :country-id="83"
                    ref="school_search"
                    :value="interviewSchool"
                    @change="selectSchool"
                  />
                  <el-button type="primary"
                             :disabled="!canConfirmSchool"
                             @click="confirmInterview">预约</el-button>
                </div>
              </div>
              <div class="user-detail-text">
                <div class="text-content">
                  <span>面试时间</span>
                  <span>{{ currentInterviewObj.interview_time || '未排期' }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="person-area user-detail-commonbg">
            <div class="user-detail-title">
              <h3><i></i>顾问信息</h3>
              <el-button @click="openEdit(6)" state-key="fib.jiemo.net/h5/user/edit-顾问信息" :state-status="true">编辑</el-button>
            </div>
            <div class="user-detail-list">
              <div class="list-content">
                <span>咨询老师</span>
                <span>{{ editData.crm_sayer_str || '-' }}</span>
              </div>
              <div class="list-content">
                <span>申请老师</span>
                <span>{{ editData.crm_writer_str || '-' }}</span>
              </div>
              <div class="list-content">
                <span>规划老师</span>
                <span>{{ editData.crm_planning_str || '-' }}</span>
              </div>
              <div class="list-content">
                <span>文书老师</span>
                <span>{{ editData.crm_document_str || '-' }}</span>
              </div>
              <div class="list-content">
                <span>代言计划</span>
                <span>
                  <jm-dict-select
                    clearable
                    v-model="editData.rugby_people"
                    type="dataset"
                    dict-type="student"
                    name="rugbyPeople"
                    :show="true"
                  />
                </span>
              </div>
              <div class="list-content">
                <span>合同号</span>
                <span>{{ editData.contract_number || '-' }}</span>
              </div>
              <div class="list-content">
                <span>资料发送</span>
                <span>{{ editData.material_send_str || '-' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-area return-info-area" v-show="tabLock === 3">
          <div class="return-second-tab">
            <el-button @click="returnVisitClick(1)" :class="returnTabLock ? 'active' : ''">学生回访</el-button>
            <el-button @click="returnVisitClick(2)" :class="!returnTabLock ? 'active' : ''">运营回访</el-button>
          </div>
          <data-list :url="returnListUrl"
                     :refresh.sync="refresh">
            <template slot-scope="{ item }">
              <div class="person-area user-detail-commonbg">
                <div class="user-detail-list">
                  <div class="list-content">
                    <span>方式</span>
                    <span>{{ item.visit_kind }}</span>
                  </div>
                  <div class="list-content">
                    <span>回访类型</span>
                    <span>{{ item.visit_type }}</span>
                  </div>
                  <div class="list-content">
                    <span>记录</span>
                    <span>{{ item.vist_str }}</span>
                  </div>
                  <div class="btn-content">
                    <span>{{ item.visit_creator }} 于 {{ item.instime }} 创建</span>
                    <div class="btn-area" v-if="!infoReadOnly">
                      <el-button @click="showPopup(item)">编辑</el-button>
                      <el-button @click="deleteVisit(item.id)">删除</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </data-list>
        </div>
        <div class="tab-area pay-info-area" v-show="tabLock === 4">
          <data-list :url="`/index/order/student/crmid/${crmId}`"
                     :refresh.sync="refresh1">
            <template slot-scope="{ item }">
              <div class="person-area user-detail-commonbg">
                <div class="user-detail-list">
                  <div class="list-content">
                    <span>合同编号</span>
                    <span>{{ item.contract_number }}</span>
                  </div>
                  <div class="list-content">
                    <span>产品名称</span>
                    <span>{{ item.goods_name }}</span>
                  </div>
                  <div class="list-content">
                    <span>服务合同额</span>
                    <span>{{ item.serve_money }}</span>
                  </div>
                  <div class="list-content">
                    <span>实付金额</span>
                    <span>{{ item.price }}</span>
                  </div>
                  <div class="list-content">
                    <span>{{ item.pay_time_countdown === 1 ? '最后支付时间' : '支付时间' }}</span>
                    <span v-if="item.pay_time_countdown === 1">
                      <span >{{ item.time_expire }}</span>
                    </span>
                    <span v-else>
                      {{ item.order_time }}
                    </span>
                  </div>
                  <div class="list-content">
                    <span>类型</span>
                    <span>{{ item.order_method === 1 ? '支付邀约' : '财务报账' }}</span>
                  </div>
                  <div class="btn-content">
                    <div class="btn-area">
                      <el-button v-show="item.buttons[0].label !== '刷新' && item.buttons[0].label !== '法务备注' && item.buttons[0].label !== '财务备注'" :disabled="!item.buttons[0].actived" @click="showFinancial({ type: item.order_method, orderNum: item.order_number, crm_id: item.crm_id })">{{ item.buttons[0].label }}</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </data-list>
        </div>
      </div>
    </scroll-refresh>
    <div class="bottom-fixed-wrap">
      <div class="btn-area" state-key="fib.jiemo.net/h5/user/bottom-快速回访" :state-status="true">
        <el-button @click="showPopup({ crm_id: crmId })">快速回访</el-button>
      </div>
      <div class="btn-area" state-key="fib.jiemo.net/h5/user/bottom-预约回访" :state-status="true">
        <el-button @click="showPopupPlantask({ crm_id: crmId, tk_type: 1 })">预约回访</el-button>
      </div>
      <div class="btn-area" v-show="!syncDialog.finished" state-key="fib.jiemo.net/h5/user/bottom-同步其他系统" :state-status="true">
        <el-button @click="showSyncDialog">同步其他系统</el-button>
      </div>
      <!-- <div class="btn-area" state-key="fib.jiemo.net/h5/user/bottom-支付邀约" :state-status="true">
        <el-button @click="showFinancial({ type: 1, crm_id: crmId })">支付邀约</el-button>
      </div>
      <div class="btn-area" state-key="fib.jiemo.net/h5/user/bottom-财务报账" :state-status="true">
        <el-button @click="showFinancial({ type: 2, crm_id: crmId })">财务报账</el-button>
      </div> -->
    </div>
    <popup-returnvisit :visible="isEditLock" :data-set="visitForm" :crm_id="parseInt(crmId)" :show-lock.sync="returnVisitLock">
      <el-button slot="close-button" @click="closePopup" class="btn-close-popup"><font>×</font></el-button>
    </popup-returnvisit>
    <popup-plantask :show-lock.sync="plantaskLock" :title="`预约回访`" :task-form="taskForm">
      <el-button slot="close-button" @click="closePopupPlantask" class="btn-close-popup"><font>×</font></el-button>
    </popup-plantask>
    <popup-q-rcode :show-lock.sync="qrcodeLock" :crm-id="parseInt(crmId)" :reset-lock="false" v-if="crmId">
      <el-button slot="close-button" @click="closeQRcode" class="btn-close-popup"><font>×</font></el-button>
    </popup-q-rcode>
    <popup-financial :show-lock.sync="financialLock" :financial-form="financialForm">
      <el-button slot="close-button" @click="closeFinancial" class="btn-close-popup"><font>×</font></el-button>
    </popup-financial>
    <sync-dialogs
      class="sync-dialog-wapwrap"
      v-if="isFibSite"
      @confirm="doSync"
      @loaded="syncDataLoaded"
      :type="syncType"
      width="94%"
      :from="editData.id"
      :visible.sync="syncDialogVisible">
    </sync-dialogs>
  </div>
</template>
<script>
import header from './compoments/header';
import scrollRefresh from './compoments/scrollRefresh';
import DataList from './compoments/dataList';
import popupReturnVisit from './compoments/popupReturnVisit';
import popupPlantask from './compoments/popupPlantask';
import popupQRcode from './compoments/popupQRcode';
import popupFinancial from './compoments/popupFinancial';
import trainingCard from './compoments/trainingCard';
import syncDialogsMixin from '@/components/syncDialogsMixin';
import { CREATOR_FIB_TO_TRAINING, CREATOR_FIB_TO_JOB } from '@/const/sync';

import student from './../student/student';

import * as UserApi from '@/api/user.js';
import * as Country from '@/const/index.js';
import {
  // jmAreaselect,
  // jmChannel,
  jmDictSelect,
  jmSchoolSearch
} from '@/components/tool';
import router from '@/router';
import { isEmpty } from '@/utils/utils';
import permissionMixin from '../student/permissionMixin';
import VueCountdown from '@xkeshi/vue-countdown';

let task = {
  tk_time: '',
  tk_type: '',
  tk_name: '',
  tk_memo: '',
  tk_create: '',
};

let financial = {
  crm_id: 0,
  order_method: 1,
};

export default {
  mixins: [student, permissionMixin, syncDialogsMixin],
  components: {
    'wap-header': header,
    'data-list': DataList,
    'popup-returnvisit': popupReturnVisit,
    'popup-plantask': popupPlantask,
    jmDictSelect,
    jmSchoolSearch,
    popupQRcode,
    popupFinancial,
    scrollRefresh,
    countdown: VueCountdown,
    trainingCard
  },
  data() {
    return {
      returnListUrl: `/index/visit/paginate/userid/${this.$route.params.crmid}`,
      returnTabLock: true,
      syncDialogVisible: false,
      isEditLock: false,
      crmId: this.$route.params.crmid,
      refresh: false,
      refresh1: false,
      tabLock: 1,
      returnVisitLock: false,
      plantaskLock: false,
      qrcodeLock: false,
      financialLock: false,
      syncData: {},
      editData: {
        id: 0,
        create_person: null,
        custom_hope_country: [], // 意向国家
        thinking_pic: [], // 脑图,
        custom_course: [], // 课程
        custom_hope_way: [], // 专业
        custom_refusal: null,
        upgrade_plan_teacher: '',
        crm_sayer: -1,
        deleteSchoolIds: [], // 删除选校信息
        schools: [], // 选校信息数据
        country_business_str: '-',
        join_upgrade_plan: null,
        test_upgrade_plan: null,
        send_upgrade_plan: null,
        custom_education: null,
        custom_detail: null,
        custom_place_area: null,
        custom_place_city: null,
        custom_level: null,
        crm_level_lv: null,
        crm_gathering_time: null,
        crm_final_pay_time: null,
        crm_tel: '',
        crm_cse: null,
        crm_writer: null,
        crm_document: null,
        crm_training: null,
        crm_manager: null,
        crm_planning: '',
        jm_contract_number: null,
        custom_year: null,
        custom_month: null,
        signing_date: '',
        custom_graduation: null,
        custom_birthday: '',
        join_upgrade_plan_time: null,
        send_upgrade_plan_time: null,
        test_upgrade_plan_time: null,
        custom_course_type: 0,
        identity: 0,
        has_jp_score: null,
        has_en_score: null,
        sign_the_contract: 0,
        examination_of_culture: '',
        culture_sign_date: null,
        jiemo_vip_str: '否',
        short_study_abroad_str: '否',
        extra_memo_files: [],
        extra_memo_text: '',
        jiemo_contract_sign: '',
        take_order: 0,
        take_order_number: '',
        radio_and_check: '',
        signup_form: {}
      },
      currentInterviewObj: {},
      interviewSchool: {},
      taskForm: task,
      financialForm: financial,
      visitForm: {
        crmid: 0,
        id: 0
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    UserApi.getBaseInfo(to.params.crmid)
      .then(({ data }) => {
        next((vm) => {
          vm.setStudentData(data);
        });
      })
      .catch(() => {
        router.replace({ name: 'h5UserList' });
      });
    return true;
  },
  computed: {
    /**
     * 是否有签约类型
     */
    hasSignType() {
      const enableCountry = [
        Country.COUNTRY_GB,
        // Country.COUNTRY_JP,
        Country.COUNTRY_AU,
        Country.COUNTRY_IE,
        Country.COUNTRY_NZ,
        Country.COUNTRY_SG,
        Country.COUNTRY_FR,
        Country.COUNTRY_HK
      ];
      return this.isInCountry(enableCountry);
    },
    /* 是否是韩国学生 */
    isJiemoKrStudent() {
      const enableCountry = [Country.COUNTRY_KR];
      console.log(this.isInCountry(enableCountry));
      return this.isInCountry(enableCountry);
    },
    /**
     * 是否是日韩学生
     * @return {Boolean} [description]
     */
    isJiemoJpKrStudent() {
      const enableCountry = [Country.COUNTRY_JP, Country.COUNTRY_KR];
      return this.isInCountry(enableCountry);
    },
    /**
     * 是否是芥末日本学生
     */
    isJiemoJpStudent() {
      const enableCountry = [Country.COUNTRY_JP];
      return this.isInCountry(enableCountry);
    },
    /**
     * 是否为日本语言学校资源
     */
    isLanguageSchool() {
      return (
        this.$inCountry([83]) && this.editData.custom_hope_country.includes(83)
      );
    },
    /**
     * 必须有报名表
     */
    mustHaveInterviewForm() {
      if (this.editData.custom_hope_country.includes(83) || this.editData.custom_hope_country.includes(672)) {
        return true;
      }
      return false;
    },
    // /**
    //  * 是否有报名表
    //  */
    hasSignUpForm() {
      return !isEmpty(this.editData.signup_form);
    },
    /**
     * 可以确认面试学校
     */
    canConfirmSchool() {
      if (!this.currentInterviewObj) {
        return false;
      }

      if (
        isEmpty(this.editData.signup_form) &&
        isEmpty(this.uploadedSignForm)
      ) {
        return false;
      }

      // 上一个面试学校与新选择的不是同一个
      return !this.currentInterviewObj.is_current;
    },
    /**
     * 面试学期
     */
    interviewTerm() {
      return `${this.editData.custom_year}-${this.editData.custom_month}-01`;
    },
  },
  methods: {
    // 倒计时格式化
    counTimeFormat(time) {
      let date3 = new Date(time) - new Date();
      // 计算出相差天数
      let days = Math.floor(date3 / (24 * 3600 * 1000));
      // 计算出小时数
      let leave1 = date3 % (24 * 3600 * 1000); // 计算天数后剩余的毫秒数
      let hours = Math.floor(leave1 / (3600 * 1000));
      // 计算相差分钟数
      let leave2 = leave1 % (3600 * 1000); // 计算小时数后剩余的毫秒数
      let minutes = Math.floor(leave2 / (60 * 1000));
      // 计算相差秒数
      let leave3 = leave2 % (60 * 1000); // 计算分钟数后剩余的毫秒数
      let seconds = Math.round(leave3 / 1000);
      return `还剩 ${days}天 ${hours}小时 ${minutes}分钟 ${seconds}秒`;
    },
    // 回访二级点击
    returnVisitClick(val) {
      if (val === 1) {
        this.returnListUrl = `/index/visit/paginate/userid/${this.crmId}`;
        this.returnTabLock = true;
      } else if (val === 2) {
        this.returnListUrl = `/index/operate_visit/paginate/userid/${this.crmId}`;
        this.returnTabLock = false;
      }
      this.refresh = true;
    },
    syncDataLoaded(data) {
      this.syncDialog = data;
    },
    /**
     * 同步资源到其他系统
     */
    doSync({ message, targetLan, system }) {
      const notifyHandle = this.$message('同步中...');
      let url = '';
      let sycData = {};
      if (system === CREATOR_FIB_TO_TRAINING) { // 考培系统
        if (this.editData.custom_hope_country.indexOf(1868) === -1) {
          this.editData.custom_hope_country.push(1868);
        }
        url = '/index/student/syncToTraining';
        sycData = {
          id: this.editData.id,
          message,
          targetLan
        };
      }
      if (system === CREATOR_FIB_TO_JOB) { // 求职系统
        url = '/index/student/syncToJob';
        sycData = {
          id: this.editData.id,
          message,
        };
      }
      this.$http._post({
        url: url,
        data: sycData,
      }).then(() => {
        notifyHandle.close();
        this.$message.success('同步成功');
        this.syncDialogVisible = false;
      });
    },
    /**
     * Description: 支付时间倒计时
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    getCountdownTime(expire) {
      if (!expire) {
        return false;
      }
      let expireTimestamp = new Date(expire).getTime();
      let nowTimestamp = new Date().getTime();
      let timeLeft = expireTimestamp - nowTimestamp;
      console.log(timeLeft);
      return timeLeft > 0 ? timeLeft : false;
    },
    // 回访删除操作
    async deleteVisit(id) {
      try {
        await this.$confirm('此操作将删除此条信息，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await this.doDelete(id);
      } catch (e) {
        this.$message.info('已取消删除');
      }
    },
    async doDelete(id) {
      try {
        await this.$http._delete({
          url: `/index/visit/resource/id/${id}`,
        });
        this.$message.success('删除成功');
        window.location.reload();
      } catch (e) {
        this.$message.error('删除失败');
      }
    },
    /**
     * 判断当前学生意向国家是否在国家列表内
     */
    isInCountry(countries) {
      return countries.some((item) => {
        return this.editData.custom_hope_country.indexOf(item) > -1;
      });
    },
    // 打开图片查看弹窗
    openShowImg: function(url) {
      window.location.href = url;
    },
    // 打开二维码弹窗
    openEwm: function() {
      this.qrcodeLock = true;
    },
    // 关闭二维码弹窗
    closeQRcode: function() {
      this.qrcodeLock = false;
    },
    // 复制点击
    copyClick: function() {
      this.$message.success('复制成功');
    },
    // 编辑点击
    openEdit: function(etype) {
      this.$router.push({ name: 'h5EditUser', params: { anchor: etype } });
    },
    // 打开财务报账或支付邀约
    showFinancial(data) {
      this.financialForm = Object.assign({}, financial, data);
      this.financialLock = true;
    },
    // 关闭财务报账或支付邀约
    closeFinancial() {
      this.financialLock = false;
    },
    // 合格证下载
    downloadCert(cert) {
      if (cert.asset_id) {
        this.$router.push({ name: 'h5PdfView', params: { pdfurl: cert.asset.file_path } });
        // this.$http.getFile({ url: cert.asset.file_path, filename: cert.asset.filename });
      } else {
        this.$message.error('合格证未上传');
      }
    },
    // 切换点击
    tabClick: function(tab) {
      this.tabLock = tab;
      if (tab === 3) {
        this.refresh = true;
      } else if (tab === 4) {
        this.refresh1 = true;
      }
    },
    // 关闭快速回访弹窗
    closePopup: function() {
      this.returnVisitLock = false;
    },
    showPopup: function(data) {
      this.visitForm = data;
      this.visitForm.crmid = data.crm_id;
      if (data.id) {
        this.isEditLock = true;
      } else {
        this.isEditLock = false;
      }
      this.returnVisitLock = true;
    },
    // 关闭计划任务弹窗
    closePopupPlantask: function() {
      this.plantaskLock = false;
    },
    // 打开计划任务弹窗
    showPopupPlantask: function(taskData = {}) {
      this.taskForm = Object.assign({}, task, taskData);
      console.log('plantaskForm:', this.taskForm);
      this.plantaskLock = true;
    },
    updateCurrentInterview(interview) {
      this.currentInterviewObj = Object.assign(
        {},
        this.currentInterviewObj,
        interview
      );
    },
    /**
     * 选择学校
     */
    async selectSchool(v) {
      console.log(v);
      if (!v) {
        return false;
      }

      let message = '选择学校后，学生即将开始面试流程';
      if (this.originInterviewSchool) {
        message = `您确认要将学生学校修改为“${v.sh_name_cn}”吗？`;
      }

      try {
        await this.$confirm(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        });
        await this.startInterviewPlan(v);
        this.interviewSchool = v;
      } catch (e) {
        console.log('取消选择新的学校，还原原有学校');
        this.interviewSchool = this.originInterviewSchool
          ? { ...this.originInterviewSchool }
          : null;
      }
    },
    /**
     * 开启面试计划
     */
    async startInterviewPlan(school) {
      const { data } = await this.$http._post({
        url: '/interview/plan/start',
        data: {
          school,
          userId: this.editData.id,
          term: this.interviewTerm
        }
      });
      this.$message({
        message: '选择面试学校成功',
        type: 'success'
      });
      this.updateCurrentInterview(data);
    },
    /**
     * 确认特殊报名表
     */
    async confirmInterview() {
      try {
        await this.$confirm(
          '确认后报名表将同步到面试系统，请老师确认内容',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        );
      } catch (e) {
        return false;
      }
      const { data } = await this.$http._post({
        url: '/interview/plan/confirmInterview',
        data: {
          id: this.currentInterviewObj.id,
          term: this.interviewTerm,
          school: this.interviewSchool
        }
      });
      this.updateCurrentInterview(data);
      this.$message.success('预约面试成功！');
    },
    currentInterview() {
      this.$http._post({
        url: '/index/student/currentVisibleInterview',
        data: { id: this.editData.id }
      }).then(({ data }) => {
        if (data) {
          this.currentInterviewObj = data;
          this.interviewSchool = {
            interview_id: data.id,
            interview_is_special: data.is_special,
            sh_id: data.school_id,
            sh_name_cn: data.school_name,
            sh_name_en: data.school_name_en,
            value: data.school_name
          };
          this.originInterviewSchool = { ...this.interviewSchool };
        }
      });
    },
    setStudentData(data) {
      this.editData = Object.assign(this.editData, data);
      if (
        this.editData.crm_sayer &&
        this.editData.crm_training &&
        this.editData.crm_sayer !== this.editData.crm_training
      ) {
        this.is_crm_sayer = true;
      }
      this.formatStudentData();
    },
    formatStudentData() {
      if (this.editData.custom_year !== null) {
        this.editData.custom_year = String(this.editData.custom_year);
      }
      if (this.editData.custom_month !== null) {
        this.editData.custom_month = String(this.editData.custom_month);
      }
      if (this.editData.custom_graduation !== null) {
        this.editData.custom_graduation = String(this.editData.custom_graduation);
      }
      if (this.editData.channel_str !== null) {
        this.editData.channel_str = this.editData.channel_str.split(' ');
      }
      if (this.editData.crm_zhuanxiang !== null) {
        let zhuanxiang = { 1: '芥末转前程', 2: '前程转芥末', 3: 'call center激活' };
        this.editData.crm_zhuanxiang = zhuanxiang[this.editData.crm_zhuanxiang] ? zhuanxiang[this.editData.crm_zhuanxiang] : '-';
      }
    },
    /**
     * 查看用户最新订单法务状态
     */
    initOrderLaw() {
      let power = this.$hasPermission([121, 122, 123, 124, 125]);
      this.orderLaw = !power;
      if (this.orderLaw) {
        return this.orderLaw;
      }
      // console.log('power:' + power);
      if (this.editData.id) {
        this.$http._post({
          url: '/index/order/student',
          data: {
            crmid: this.editData.id
          }
        }).then(({ data }) => {
          if (data && data.data) {
            if (typeof data.data[0] === 'object' && data.data[0].law_status === '已确认') {
              this.orderLaw = true;
            }
          }
          // console.log('LawStatus:', this.orderLaw);
        });
      }
    },
  },
  watch: {},
  mounted() {
    this.$nextTick(() => {
      this.isLanguageSchool && this.currentInterview();
      this.initOrderLaw();
    });
  },
  created() {},
  filters: {
    formatDate: function (value) {
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? (`0${MM}`) : MM;
      let d = date.getDate();
      d = d < 10 ? (`0${d}`) : d;
      let h = date.getHours();
      h = h < 10 ? (`0${h}`) : h;
      let m = date.getMinutes();
      m = m < 10 ? (`0${m}`) : m;
      let s = date.getSeconds();
      s = s < 10 ? (`0${s}`) : s;
      return `${y}-${MM}-${d} ${h}:${m}:${s}`;
    }
  },
};
</script>
<style>
  .bluefire-wap-wrap .sync-dialog-wapwrap .el-dialog{
    border-radius: 4vw;
  }
  .bluefire-wap-wrap .sync-dialog-wapwrap .el-dialog__title{
    font-size: 4vw;
  }
  .bluefire-wap-wrap .sync-dialog-wapwrap .el-dialog__header{
    padding: 4vw;
    padding-bottom: 0;
  }
  .bluefire-wap-wrap .sync-dialog-wapwrap .el-dialog__body{
    padding: 4vw;
  }
  .bluefire-wap-wrap .sync-dialog-wapwrap .el-form-item{
    margin-bottom: 3vw;
  }
  .bluefire-wap-wrap .sync-dialog-wapwrap .el-dialog__body .el-form{
    margin-top: 0;
  }
  .bluefire-wap-wrap .sync-dialog-wapwrap .el-dialog__headerbtn{
    background: none;
    position: absolute;
    bottom: -12vw;
    left: 50%;
    top: auto;
    right: auto;
    transform: translateX(-50%);
    width: 7.7vw;
    height: 7.7vw;
    line-height: 7.7vw;
    padding: 0;
    text-align: center;
    border-radius: 100%;
    border: 0.7px solid #fff;
    font-size: 0;
  }
  .bluefire-wap-wrap .sync-dialog-wapwrap .el-dialog__headerbtn .el-dialog__close{
    display: inline-block;
    vertical-align: middle;
    font-size: 4vw;
    position: relative;
    color: #fff;
  }
  .bluefire-wap-wrap .basic-info-area .channel-area .channel-list{
    width: 74.4vw;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
  }
  .bluefire-wap-wrap .basic-info-area .channel-area .channel-list span{
    font-size: 4vw;
  }
  .bluefire-wap-wrap .basic-info-area .channel-area .channel-list span i{
    display: inline-block;
    margin: 0 1.2vw;
    border-left: 1.5vw solid #0496ff;
    border-top: 1vw solid transparent;
    border-bottom: 1vw solid transparent;
  }
  .bluefire-wap-wrap .basic-info-area .channel-area .channel-list span:last-of-type i{
    display: none;
  }
  .bluefire-wap-wrap .user-detail-wrap .infinite-list-wrapper ul li{
    background: none;
    border-radius: 0;
    margin-bottom: 0;
    padding: 0;
  }
  .bluefire-wap-wrap .user-detail-commonbg{
    background: #fff;
    border-radius: 2vw;
    margin-top: 3vw;
  }
  .bluefire-wap-wrap .user-detail-title{
    position: relative;
    padding: 4.5vw 3.46vw;
  }
  .bluefire-wap-wrap .user-detail-title h3{
    font-size: 4.8vw;
    font-weight: 600;
    line-height: 6vw;
    position: relative;
    padding-left: 2vw;
  }
  .bluefire-wap-wrap .user-detail-title h3 i{
    position: absolute;
    left: -1vw;
    top: 50%;
    transform: translateY(-50%);
    width: 1vw;
    height: 4vw;
    background: #0496ff;
    border-radius: 0.8vw;
  }
  .bluefire-wap-wrap .user-detail-title .el-button{
    position: absolute;
    right: 4vw;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    border-radius: 0;
    background: none;
    padding: 0;
    font-size: 3.73vw;
    color: #0496ff;
    background: url(../../assets/wap/icon-userdetail-6.png) no-repeat left center;
    background-size: 3.2vw auto;
    padding-left: 4.5vw;
  }
  .bluefire-wap-wrap .user-detail-wrap .remark-area{
    padding-bottom: 4vw;
  }
  .bluefire-wap-wrap .remark-content{
    background: #FFF5EC;
    color: #FF9C65;
    margin: 0 4vw;
    border-radius: 2vw;
    padding: 3vw 3.8vw;
    line-height: 5.4vw;
    font-size: 3.73vw;
  }
  .bluefire-wap-wrap .list-content .remark-content{
    margin: 0;
    width: 100%;
  }
  .bluefire-wap-wrap .user-detail-list{
    padding: 0 4vw;
  }
  .bluefire-wap-wrap .user-detail-list .list-content{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 3.5vw 0;
    border-bottom: 0.7px dashed #dadada;
  }
  .bluefire-wap-wrap .user-detail-list .list-content.wrapmode{
    flex-wrap: wrap;
  }
  .bluefire-wap-wrap .user-detail-list .list-content:last-of-type{
    border-bottom: none;
  }
  .bluefire-wap-wrap .user-detail-list .list-content span{
    font-size: 3.73vw;
    display: inline-block;
    line-height: 5vw;
  }
  .bluefire-wap-wrap .user-detail-list .list-content > span:first-of-type{
    color: #888;
    margin-right: 4vw;
    white-space: nowrap;
  }
  .bluefire-wap-wrap .user-detail-list .btn-content{
    padding-top: 3.5vw;
  }
  .bluefire-wap-wrap .user-detail-list .btn-content > span{
    display: block;
    font-size: 3.73vw;
    color: #888;
    padding: 0 0 3.5vw;
  }
  .bluefire-wap-wrap .user-detail-list .btn-content .btn-area{
    text-align: right;
    padding-bottom: 5vw;
  }
  .bluefire-wap-wrap .user-detail-list .btn-content .btn-area .el-button{
    padding: 0 5vw;
    height: 8vw;
    line-height: 8vw;
    border-radius: 4vw;
    border: 0.6px solid #ccc;
    color: #333;
    background: none;
  }
  .bluefire-wap-wrap .user-detail-list .btn-content .btn-area .el-button.is-disabled{
    background: #e2e2e2;
  }
  .bluefire-wap-wrap .back-list-wrap{
    background: #DBF0FF;
    border-radius: 2vw;
    padding: 3vw 3.8vw;
    margin-top: 2vw;
    max-height: 32vw;
    overflow-y: auto;
    width: 100%;
  }
  .bluefire-wap-wrap .back-list-wrap .back-area{
    border-bottom: 0.7px dashed #fff;
    padding-bottom: 2vw;
    margin-bottom: 2vw;
  }
  .bluefire-wap-wrap .back-list-wrap .back-area:last-of-type{
    border-bottom: none;
    margin-bottom: 0;
  }
  .bluefire-wap-wrap .back-list-wrap .back-area span{
    font-size: 3.73vw;
    color: #888;
    line-height: 5.4vw;
  }
  .bluefire-wap-wrap .back-list-wrap .back-area span:nth-of-type(2){
    color: #3fafff;
  }
  .bluefire-wap-wrap .back-list-wrap .back-area span:nth-of-type(3){
    color: #f69e53;
    display: block;
  }
</style>
<style scoped>
  .user-detail-wrap .header-area{
    padding: 4vw 4vw 0;
    background: url(../../assets/wap/bg-userdetail-top.jpg) no-repeat center top;
    background-size: 100%;
  }
  .user-detail-wrap .header-area .info-area{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .user-detail-wrap .header-area .info-area .name-area{
    width: 70%;
  }
  .user-detail-wrap .header-area .info-area .name-area h3{
    color: #fff;
    font-size: 5.8vw;
    font-weight: 600;
  }
  .user-detail-wrap .header-area .info-area .name-area h3 font{
    display: inline-block;
    vertical-align: text-bottom;
  }
  .user-detail-wrap .header-area .info-area .name-area h3 i{
    font-size: 4.2vw;
    font-weight: normal;
    display: inline-block;
    vertical-align: text-bottom;
    margin-left: 2.4vw;
  }
  .user-detail-wrap .header-area .info-area .name-area h4{
    font-size: 3.73vw;
    color: rgba(168, 250, 255, 0.6);
    font-weight: normal;
    margin-top: 0.5vw;
  }
  .user-detail-wrap .header-area .info-area .btn-area{
    width: 30%;
    text-align: right;
    position: relative;
    margin-top: 0.8vw;
  }
  .user-detail-wrap .header-area .info-area .btn-area img{
    cursor: pointer;
    width: 5.3vw;
    height: 5.3vw;
    -webkit-tap-highlight-color: transparent;
    margin-right: 16vw;
  }
  .user-detail-wrap .header-area .info-area .btn-area .el-button{
    background: none;
    height: 5.6vw;
    line-height: 5.6vw;
    padding: 0 4vw;
    border: none;
    position: absolute;
    right: -4vw;
    top: 0;
    font-size: 3.73vw;
    background: linear-gradient(90deg, #61C6FF -3.19%, #52ACFF 103.19%);
    border-radius: 2.8vw 0 0 2.8vw;
    color: #fff;
  }
  .user-detail-wrap .header-area .info-area .chat-area{
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 4vw 3vw 0;
  }
  .user-detail-wrap .header-area .info-area .chat-area .chat-content{
    white-space: nowrap;
  }
  .user-detail-wrap .header-area .info-area .chat-area .chat-content img{
    display: inline-block;
    vertical-align: middle;
    height: 4vw;
  }
  .user-detail-wrap .header-area .info-area .chat-area .chat-content span{
    color: #fff;
    font-size: 3.73vw;
    display: inline-block;
    vertical-align: middle;
    padding: 0 2vw 0 1.5vw;
  }
  .user-detail-wrap .header-area .info-area .chat-area .chat-content .copy{
    display: inline-block;
  }
  .user-detail-wrap .header-area .info-area .chat-area .chat-content .copy button{
    background: none;
    border: none;
    font-size: 3.2vw;
    color: #fff;
    border: 1px solid #fff;
    padding: 0 0.8vw;
    height: 5vw;
    line-height: 4.6vw;
    border-radius: 2vw;
    display: inline-block;
    vertical-align: middle;
    opacity: .5;
  }
  .user-detail-wrap .header-area .card-area{
    background: #fff;
    border-radius: 2vw;
    margin-top: 2.5vw;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 4vw 0;
  }
  .user-detail-wrap .header-area .line-area{
    height: 5.6vw;
    width: 0;
    border-right: 1px solid #cdcdcd;
  }
  .user-detail-wrap .header-area .card-area .card-content{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 50%;
    padding-left: 5vw;
  }
  .user-detail-wrap .header-area .card-area .card-content img{
    width: 9vw;
    height: 9vw;
    margin-right: 3vw;
  }
  .user-detail-wrap .header-area .card-area .card-content .text-area span{
    font-size: 3.46vw;
    color: #c4c4c4;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .user-detail-wrap .header-area .card-area .card-content .text-area em{
    display: block;
    font-size: 4.26vw;
    color: #000;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .user-detail-wrap .tab-btn-area{
    background: #fff;
    width: 92vw;
    margin: 3vw auto 0;
    border-radius: 2vw;
    display: flex;
    justify-content: space-around;
    padding: 0 4vw 0 2vw;
  }
  .user-detail-wrap .tab-btn-area .el-button{
    display: inline-block;
    border-radius: 0;
    padding: 0;
    border: none;
    background: none;
    height: 13vw;
    line-height: 13vw;
    font-size: 4vw;
    transition: all linear 0.2s;
    position: relative;
    color:#9a9a9a
  }
  .user-detail-wrap .tab-btn-area .el-button i{
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0%;
    height: 0.8vw;
    background: transparent;
    transition: all linear 0.2s;
  }
  .user-detail-wrap .tab-btn-area .el-button.active{
    color: #0496FF;
  }
  .user-detail-wrap .tab-btn-area .el-button.active i{
    background: #0496FF;
    width: 84%;
  }
  .basic-info-area{
    padding: 0 4vw;
  }
  .basic-info-area .channel-area{
    background: #fff;
    border-radius: 2vw;
    margin-top: 3vw;
    display: flex;
    justify-content: space-between;
    padding: 2vw;
    align-items: center;
  }
  .basic-info-area .channel-area > span{
    display: inline-block;
    width: 11.2vw;
    height: 10.2vw;
    background: rgba(4, 150, 255, 0.1);
    border-radius: 1.6vw;
    line-height: 4.6vw;
    text-align: center;
    color: #0496FF;
    padding-top: 1vw;
  }


  .bottom-fixed-wrap{
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 11;
    width: 100%;
    height: 17vw;
    display: flex;
    justify-content: space-around;
    padding: 1.5vw 0 0;
    background: #fff;
    border-top: 0.5px solid #f5f5f5;
  }
  .bottom-fixed-wrap .btn-area .el-button{
    color: #9A9A9A;
    font-size: 2.9vw;
    background: none;
    border: none;
    padding: 7.5vw 0 0;
    height: auto;
    line-height: 4vw;
  }
  .bottom-fixed-wrap .btn-area:nth-of-type(1) .el-button{
    background: url(../../assets/wap/icon-userdetail-8.png) no-repeat center top;
    background-size: 6.4vw 6.4vw;
  }
  .bottom-fixed-wrap .btn-area:nth-of-type(2) .el-button{
    background: url(../../assets/wap/icon-userdetail-12.png) no-repeat center top;
    background-size: 6.4vw 6.4vw;
  }
  .bottom-fixed-wrap .btn-area:nth-of-type(3) .el-button{
    background: url(../../assets/wap/icon-userdetail-11.png) no-repeat center top;
    background-size: 6.4vw 6.4vw;
  }
  .bottom-fixed-wrap .btn-area:nth-of-type(4) .el-button{
    background: url(../../assets/wap/icon-userdetail-9.png) no-repeat center top;
    background-size: 6.4vw 6.4vw;
  }
  .bottom-fixed-wrap .btn-area:nth-of-type(5) .el-button{
    background: url(../../assets/wap/icon-userdetail-10.png) no-repeat center top;
    background-size: 6.4vw 6.4vw;
  }
  .sign-info-area{
    padding: 0 4vw;
  }
  .user-detail-interview{
    padding: 0 3vw;
  }
  .user-detail-interview .link-area{
    display: flex;
    justify-content: space-between;
  }
  .user-detail-interview .link-area .first-link{
    width: 38.4vw;
    box-shadow: 0 0 1.6vw rgba(173, 173, 173, 0.25);
    border-radius: 2vw;
    padding: 2vw;
  }
  .user-detail-interview .link-area .first-link .top-area{
    padding-left: 10.5vw;
    background: url(../../assets/wap/icon-userdetail-inter1.png) no-repeat 1vw center;
    background-size: auto 7.2vw;
  }
  .user-detail-interview .link-area .first-link .top-area h3{
    font-size: 3.73vw;
    font-weight: normal;
  }
  .user-detail-interview .link-area .first-link .top-area .el-button{
    background: none;
    padding: 0;
    border: none;
    color: #0496ff;
    font-size: 3.73vw;
  }
  .user-detail-interview .link-area .first-link .bottom-area{
    margin-top: 2vw;
    font-size: 3.2vw;
    color: #bfbfbf;
  }
  .user-detail-interview .link-area .first-link .bottom-area span{
    display: block;
    line-height: 4.6vw;
  }
  .user-detail-interview .link-area .open-showimg-area{
    cursor: pointer;
    box-shadow: 0 0 1.6vw rgba(173, 173, 173, 0.25);
    border-radius: 2vw;
    padding: 2vw;
    width: 21.33vw;
    text-align: center;
  }
  .user-detail-interview .link-area .open-showimg-area .img-area{
    height: 15vw;
    line-height: 15vw;
  }
  .user-detail-interview .link-area .open-showimg-area .img-area img{
    display: inline-block;
    vertical-align: middle;
    width: 7.5vw;
  }
  .user-detail-interview .link-area .open-showimg-area:last-of-type .img-area img{
    width: 10vw;
  }
  .user-detail-interview .link-area .open-showimg-area h3{
    font-size: 3.73vw;
    font-weight: normal;
    color: #333;
  }
  .user-detail-interview .school-area{
    padding-top: 4vw;
  }
  .user-detail-interview .school-area > span{
    font-size: 3.73vw;
    color: #888;
    display: block;
    padding-bottom: 2.6vw;
  }
  .user-detail-interview .school-area .school-select{
    display: flex;
    justify-content: space-between;
  }
  .user-detail-interview .school-area .school-select .el-autocomplete{
    width: 75%;
  }
  .user-detail-interview .school-area .school-select .el-button{
    width: 23%;
    border: none;
  }
  .user-detail-text{
    padding: 4vw 0 6vw;
  }
  .user-detail-text .text-content{
    display: flex;
    justify-content: space-between;
  }
  .user-detail-text .text-content span{
    font-size: 3.73vw;
    line-height: 5vw;
  }
  .user-detail-text .text-content span:nth-of-type(1){
    color: #888;
  }
  .return-info-area,.pay-info-area{
    padding: 0 4vw;
  }
  .return-second-tab{
    background: #fff;
    border-radius: 3vw;
    margin-top: 1px;
    height: 12.6vw;
    line-height: 12.6vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .return-second-tab .el-button{
    border-radius: 0;
    border: none;
    background: none;
    display: inline-block;
    vertical-align: middle;
    width: 50%;
    text-align: center;
    padding: 0;
    font-size: 3.8vw;
    line-height: 4vw;
    height: 4vw;
    color: #9a9a9a;
  }
  .return-second-tab .el-button:nth-of-type(1){
    border-right: 0.7px solid #cdcdcd;
  }
  .return-second-tab .el-button.active{
    color: #0496ff;
  }
</style>
